import React, { createContext, useContext, ReactNode } from "react";

interface DisabledFieldsContextType {
  disabledFieldKeys?: Set<string>;
}

export const DisabledFieldsContext = createContext<
  DisabledFieldsContextType | undefined
>(undefined);

interface DisabledFieldsProviderProps {
  children: ReactNode;
  disabledFieldKeys?: Set<string>;
}

export const DisabledFieldsProvider: React.FC<DisabledFieldsProviderProps> = ({
  children,
  disabledFieldKeys,
}) => {
  return (
    <DisabledFieldsContext.Provider value={{ disabledFieldKeys }}>
      {children}
    </DisabledFieldsContext.Provider>
  );
};

export const useDisabledFields = () => {
  const context = useContext(DisabledFieldsContext);
  return context?.disabledFieldKeys;
};
